'use strict';

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var Block = require('ipfs-block');

var CID = require('cids');

var _require = require('multicodec'),
    getName = _require.getName;

var vd = require('varint-decoder');

var multihashing = require('multihashing-async');

var _require2 = require('../../utils'),
    isMapEqual = _require2.isMapEqual;

var _require3 = require('./message.proto'),
    Message = _require3.Message;

var Entry = require('./entry');

var BitswapMessage = /*#__PURE__*/function () {
  function BitswapMessage(full) {
    _classCallCheck(this, BitswapMessage);

    this.full = full;
    this.wantlist = new Map();
    this.blocks = new Map();
  }

  _createClass(BitswapMessage, [{
    key: "addEntry",
    value: function addEntry(cid, priority, cancel) {
      var cidStr = cid.toString('base58btc');
      var entry = this.wantlist.get(cidStr);

      if (entry) {
        entry.priority = priority;
        entry.cancel = Boolean(cancel);
      } else {
        this.wantlist.set(cidStr, new Entry(cid, priority, cancel));
      }
    }
  }, {
    key: "addBlock",
    value: function addBlock(block) {
      var cidStr = block.cid.toString('base58btc');
      this.blocks.set(cidStr, block);
    }
  }, {
    key: "cancel",
    value: function cancel(cid) {
      var cidStr = cid.toString('base58btc');
      this.wantlist.delete(cidStr);
      this.addEntry(cid, 0, true);
    }
    /*
     * Serializes to Bitswap Message protobuf of
     * version 1.0.0
     */

  }, {
    key: "serializeToBitswap100",
    value: function serializeToBitswap100() {
      var msg = {
        wantlist: {
          entries: Array.from(this.wantlist.values()).map(function (entry) {
            return {
              block: entry.cid.buffer,
              // cid
              priority: Number(entry.priority),
              cancel: Boolean(entry.cancel)
            };
          })
        },
        blocks: Array.from(this.blocks.values()).map(function (block) {
          return block.data;
        })
      };

      if (this.full) {
        msg.wantlist.full = true;
      }

      return Message.encode(msg);
    }
    /*
     * Serializes to Bitswap Message protobuf of
     * version 1.1.0
     */

  }, {
    key: "serializeToBitswap110",
    value: function serializeToBitswap110() {
      var msg = {
        wantlist: {
          entries: Array.from(this.wantlist.values()).map(function (entry) {
            return {
              block: entry.cid.buffer,
              // cid
              priority: Number(entry.priority),
              cancel: Boolean(entry.cancel)
            };
          })
        },
        payload: []
      };

      if (this.full) {
        msg.wantlist.full = true;
      }

      this.blocks.forEach(function (block) {
        msg.payload.push({
          prefix: block.cid.prefix,
          data: block.data
        });
      });
      return Message.encode(msg);
    }
  }, {
    key: "equals",
    value: function equals(other) {
      if (this.full !== other.full || !isMapEqual(this.wantlist, other.wantlist) || !isMapEqual(this.blocks, other.blocks)) {
        return false;
      }

      return true;
    }
  }, {
    key: "empty",
    get: function get() {
      return this.blocks.size === 0 && this.wantlist.size === 0;
    }
  }, {
    key: Symbol.toStringTag,
    get: function get() {
      var list = Array.from(this.wantlist.keys());
      var blocks = Array.from(this.blocks.keys());
      return "BitswapMessage <full: ".concat(this.full, ", list: ").concat(list, ", blocks: ").concat(blocks, ">");
    }
  }]);

  return BitswapMessage;
}();

BitswapMessage.deserialize = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(raw) {
    var decoded, isFull, msg;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            decoded = Message.decode(raw);
            isFull = decoded.wantlist && decoded.wantlist.full || false;
            msg = new BitswapMessage(isFull);

            if (decoded.wantlist) {
              decoded.wantlist.entries.forEach(function (entry) {
                // note: entry.block is the CID here
                var cid = new CID(entry.block);
                msg.addEntry(cid, entry.priority, entry.cancel);
              });
            } // Bitswap 1.0.0
            // decoded.blocks are just the byte arrays


            if (!(decoded.blocks.length > 0)) {
              _context3.next = 8;
              break;
            }

            _context3.next = 7;
            return Promise.all(decoded.blocks.map( /*#__PURE__*/function () {
              var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(b) {
                var hash, cid;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return multihashing(b, 'sha2-256');

                      case 2:
                        hash = _context.sent;
                        cid = new CID(hash);
                        msg.addBlock(new Block(b, cid));

                      case 5:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));

              return function (_x2) {
                return _ref2.apply(this, arguments);
              };
            }()));

          case 7:
            return _context3.abrupt("return", msg);

          case 8:
            if (!(decoded.payload.length > 0)) {
              _context3.next = 12;
              break;
            }

            _context3.next = 11;
            return Promise.all(decoded.payload.map( /*#__PURE__*/function () {
              var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(p) {
                var values, cidVersion, multicodec, hashAlg, hash, cid;
                return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        if (!(!p.prefix || !p.data)) {
                          _context2.next = 2;
                          break;
                        }

                        return _context2.abrupt("return");

                      case 2:
                        values = vd(p.prefix);
                        cidVersion = values[0];
                        multicodec = values[1];
                        hashAlg = values[2]; // const hashLen = values[3] // We haven't need to use this so far

                        _context2.next = 8;
                        return multihashing(p.data, hashAlg);

                      case 8:
                        hash = _context2.sent;
                        cid = new CID(cidVersion, getName(multicodec), hash);
                        msg.addBlock(new Block(p.data, cid));

                      case 11:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee2);
              }));

              return function (_x3) {
                return _ref3.apply(this, arguments);
              };
            }()));

          case 11:
            return _context3.abrupt("return", msg);

          case 12:
            return _context3.abrupt("return", msg);

          case 13:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
}();

BitswapMessage.Entry = Entry;
module.exports = BitswapMessage;